import { render, staticRenderFns } from "./GenericFaqDomains.vue?vue&type=template&id=c1c5fbda&scoped=true"
import script from "./GenericFaqDomains.vue?vue&type=script&lang=js"
export * from "./GenericFaqDomains.vue?vue&type=script&lang=js"
import style0 from "./GenericFaqDomains.vue?vue&type=style&index=0&id=c1c5fbda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c5fbda",
  null
  
)

export default component.exports